// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"e316c8f5","488":"64f643b4","599":"fdf74dae","653":"317004ae","762":"4c186ba7"}[chunkId] + ".chunk.js";
};